import { Component } from '@angular/core';
import { FeaturePreviewComponent } from '../feature-preview.component';

@Component({
  selector: 'app-feature-preview-overblick',
  templateUrl: './overblick.component.html',
})
export class FeaturePreviewOverblick extends FeaturePreviewComponent {}
